export enum DaysText {
    AVAILABLE_PERIODS = 'Available periods',
    VASOACTIVE_DAY_NOT_COMPILED = 'Day with vasoactive not compiled',
    DAY_WITH_ONE_VASOACTIVE = 'Day with 1 vasoactive / intropo',
    DAY_WITH_TWO_VASOACTIVE = 'Day with 2 or more vasoactives / intropi',
    GREY = '#ebf0f3',
    YELLOW = 'yellow',
    RED = 'red',
    BLUE = 'blue',
    PURPLE = 'purple',
    DAY_NOT_COMPILED = 'Day not compiled',
    DAY_WITHOUT_ASSISTENCE = 'Day WITHOUT minor respiratory assistence',
    DAY_WITH_ASSISTENCE = 'Day WITH minor respiratory assistence',
    YOU_SELECT = 'You have selected: ',
    ERROR = 'error'
}
